export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "AI驱动的加密货币交易",
    "description": "高级交易信号和自动化投资组合管理",
  },
  "navigation": {
    "dashboard": "仪表板",
    "trading": "交易",
    "signals": "信号",
    "apiCredentials": "API凭证",
    "autoTrading": "自动交易",
    "tierManagement": "等级管理",
    "referrals": "推荐",
    "accessSecurity": "访问与安全",
    "settings": "设置",
    "help": "帮助与支持",
    "login": "登录",
    "register": "注册",
    "logout": "退出",
    "home": "首页",
  },
  "auth": {
    "layout": {
      "signInToAccount": "登录您的账户",
      "or": "或",
      "createNewAccount": "创建新账户"
    },
    "login": {
      "title": "欢迎回来",
      "subtitle": "输入您的邮箱和密码登录",
      "email": "邮箱",
      "password": "密码",
      "emailPlaceholder": "name@example.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "记住我",
      "forgotPassword": "忘记密码？",
      "signIn": "登录",
      "noAccount": "没有账户？",
      "signUp": "注册",
      "googleSignIn": "使用Google继续",
      "orContinueWith": "或继续使用",
      "fillAllFields": "请填写所有字段",
      "loginSuccess": "登录成功！",
      "loginFailed": "登录失败",
      "loginFailedDescription": "登录失败",
      "googleLoginFailed": "启动Google登录失败",
      "bySigningIn": "通过登录，您同意我们的",
      "termsOfService": "服务条款",
      "privacyPolicy": "隐私政策",
      "and": "和"
    },
    "register": {
      "title": "创建账户",
      "subtitle": "输入您的信息以创建账户",
      "firstName": "名字",
      "lastName": "姓氏",
      "email": "电子邮件",
      "password": "密码",
      "confirmPassword": "确认密码",
      "agreeTerms": "点击继续即表示您同意我们的",
      "createAccount": "创建账户",
      "hasAccount": "已有账户？",
      "signIn": "登录",
      "orContinueWith": "或继续使用",
      "googleSignUp": "使用Google注册",
      "termsOfService": "服务条款",
      "privacyPolicy": "隐私政策",
      "referralCode": "推荐码（可选）",
      "placeholders": {
        "firstName": "张",
        "lastName": "三",
        "email": "姓名@示例.com",
        "password": "请输入您的密码",
        "confirmPassword": "请确认您的密码",
        "referralCode": "请输入推荐码"
      },
      "validation": {
        "minLength": "密码必须至少8个字符",
        "uppercase": "密码必须包含至少一个大写字母",
        "lowercase": "密码必须包含至少一个小写字母",
        "number": "密码必须包含至少一个数字",
        "specialChar": "密码必须包含至少一个特殊字符"
      },
      "errors": {
        "invalidReferralCode": "无效的推荐码",
        "referralValidationFailed": "无法验证推荐码。请检查您的连接并重试。",
        "googleLoginFailed": "Google登录失败",
        "googleLoginFailedTitle": "Google登录失败",
        "fillAllFields": "请填写所有字段",
        "requirementsNotMet": "密码要求未满足",
        "passwordsDoNotMatch": "密码不匹配",
        "registrationFailed": "注册失败",
        "failedToCreateAccount": "创建账户失败",
        "emailAlreadyRegistered": "邮箱已注册",
        "emailAlreadyRegisteredDescription": "此邮箱地址已存在账户。请尝试登录。",
        "connectionError": "连接错误",
        "connectionErrorDescription": "无法连接到服务器。请检查您的网络连接并重试。",
        "referralCodeError": "推荐码错误",
        "referralCodeErrorDescription": "处理您的推荐码时出现问题。您的账户仍将被创建。",
        "failedToResendEmail": "重发验证邮件失败",
        "failedToResendEmailTitle": "重发邮件失败",
        "tryAgainLater": "请稍后重试。"
      },
      "success": {
        "title": "注册成功！",
        "description": "请检查您的邮箱以验证您的账户。"
      },
      "verification": {
        "title": "检查您的邮箱",
        "description": "我们已向{{email}}发送了验证链接",
        "nextSteps": "下一步：",
        "step1": "1. 检查您的邮箱收件箱",
        "step2": "2. 点击验证链接",
        "step3": "3. 返回这里登录",
        "sending": "发送中...",
        "resendButton": "重发验证邮件",
        "backToLogin": "返回登录",
        "emailSentTitle": "验证邮件已发送",
        "emailSentDescription": "请检查您的邮箱以获取验证链接。"
      },
      "referral": {
        "validating": "验证推荐码中...",
        "validCode": "来自{{referrer}}的有效推荐码"
      }
    },
    "passwordRequirements": {
      "title": "密码要求",
      "length": "至少8个字符",
      "uppercase": "一个大写字母",
      "lowercase": "一个小写字母",
      "number": "一个数字",
      "special": "一个特殊字符",
    },
    "errors": {
      "emailInvalid": "请输入有效的邮箱地址",
      "emailRequired": "邮箱必填",
      "invalidCredentials": "无效的邮箱或密码",
      "passwordRequired": "密码必填",
      "passwordTooShort": "密码必须至少8个字符",
      "passwordsNotMatch": "密码不匹配",
      "termsRequired": "您必须同意条款和条件",
    }
  },
  "dashboard": {
    "title": "仪表板",
    "welcome": "欢迎回来！",
    "overview": "概览",
    "trading": "交易",
    "tier": "等级",
    "balance": "余额",
    "pnlToday": "盈亏",
    "totalTrades": "总交易数",
    "winRate": "胜率",
    "activeSignals": "活跃信号",
    "tradingOverview": "交易概览",
    "quickActions": "快速操作",
    "viewSignals": "查看信号",
    "autoTrading": "自动交易",
    "autoTradingDescription": "自动执行交易信号",
    "currentTier": "当前等级",
    "progressTo": "进度到等级{{tier},",
    "yourBenefits": "您的权益",
    "advancedSignals": "高级交易信号",
    "autoTradingFeatures": "自动交易功能",
    "prioritySupport": "优先支持",
    "monthlyRate": "月收益率",
    "profitShare40": "40%利润分成",
    "profitShare20": "20%利润分成",
    "profitShare10": "10%利润分成",
    "verifyingNFT": "正在验证NFT所有权...",
    "debt": "债务",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: 加载中...",
      "unavailable": "BTC/USDT: --",
      "connecting": "连接中...",
      "live": "实时",
      "error": "错误 ({{count}})",
      "24h": "24小时",
    },
    "controls": {
      "turnOn": "开启",
      "turnOff": "关闭",
      "paperAutoTrading": "模拟自动交易",
    },
    "forecast": {
      "title": "价格预测",
      "refresh": "刷新",
      "errorLoading": "图表加载错误",
      "retry": "重试",
      "noData": "无可用图表数据",
    },
    "tradingChart": {
      "forecast": "预测",
      "upperBound": "上限",
      "lowerBound": "下限",
      "support": "支撑",
      "resistance": "阻力",
      "entry": "入场",
      "stopLoss": "止损",
      "takeProfit": "止盈",
      "partialTakeProfit": "分批止盈",
      "liquidation": "清算",
      "locked": "已锁定",
      "positionLevelDialogTitle": "确认更新{{level}}",
      "positionLevelDialogDescription": "将 {{symbol}} {{side}} 的{{level}}从 {{currentPrice}} 设置为 {{newPrice}}？",
      "positionLevelDelta": "变化：{{delta}}%",
      "positionLevelConfirm": "更新{{level}}",
      "positionLevelCancel": "取消",
      "positionLevelProcessing": "更新中...",
      "positionLevelSuccess": "{{level}}已更新",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · 新{{level}}：{{price}}",
      "positionLevelFailure": "更新{{level}}失败",
      "positionLevelFailureDesc": "已恢复之前的水平。{{error}}",
      "dragHint": "拖动以移动 · 松开以确认",
      "indicators": {
        "title": "指标",
        "overlays": "叠加",
        "panes": "面板",
        "levels": "价位",
        "keyLevels": "关键位 (S/R)",
        "reset": "重置指标",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "布林带 (20, 2)",
        "bbUpper": "布林上轨",
        "bbMiddle": "布林中轨",
        "bbLower": "布林下轨",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "MACD 信号线",
      },
      "drawing": {
        "toolbar": "绘图工具",
        "select": "选择",
        "magnetMode": "磁吸: {{mode}}",
        "stayInDrawingMode": "保持绘图模式",
        "hideAll": "隐藏所有绘图",
        "showAll": "显示所有绘图",
        "undo": "撤销",
        "redo": "重做",
        "deleteSelected": "删除所选绘图",
        "clearAll": "清除所有绘图",
        "moreTools": "更多绘图工具",
        "export": "导出绘图",
        "import": "导入绘图",
        "textPrompt": "输入绘图文本",
        "loadFailure": "绘图工具不可用",
        "importEmpty": "此文件中未找到绘图",
        "importSuccess": "已导入 {{count}} 个绘图",
        "importFailure": "导入绘图失败",
        "clearConfirmTitle": "清除所有绘图？",
        "clearConfirmDescription": "这将删除当前交易对和时间周期的所有绘图。此操作无法撤销。",
        "categories": {
          "lines": "线条",
          "channels": "通道",
          "fibonacci": "斐波那契与江恩",
          "patterns": "形态",
          "elliott": "艾略特",
          "forecasting": "预测与测量",
          "volume": "成交量",
          "annotations": "标注",
          "shapes": "图形",
          "cycles": "周期",
          "regression": "回归",
        },
        "tools": {
          "trend-line": "趋势线",
          "horizontal-line": "水平线",
          "vertical-line": "垂直线",
          "ray": "射线",
          "parallel-channel": "平行通道",
          "fib-retracement": "斐波那契回撤",
          "trend-based-fib-extension": "趋势斐波那契扩展",
          "rectangle": "矩形",
          "text": "文本",
          "arrow": "箭头",
          "brush": "画笔",
          "price-range": "价格范围",
          "long-position": "多头仓位",
          "short-position": "空头仓位",
        },
      },
    },
    "realTimePerformance": "实时表现",
    "riskSettings": {
      "title": "风险管理设置",
      "paperTradingTitle": "风险管理设置 - 模拟交易",
      "loading": "加载风险设置中...",
      "investmentPercentage": "投资百分比",
      "investmentDescription": "用于交易的余额百分比 (0% - 10%)",
      "leverage": "杠杆",
      "leverageDescription": "最大: 等级{{tier}} + {{exchange}} {{market}}的{{max}}倍",
      "paperTradingLeverageDesc": "在模拟模式下，您可以使用任何杠杆设置进行测试",
      "exchange": "交易所: ",
      "configureCredentials": "在API凭证中配置",
      "warningZeroInvestment": "选择投资百分比 > 0% 以启用交易",
      "paperTradingNote": "模拟交易模式 - 不适用等级限制",
      "saveSettings": "保存设置",
      "saving": "保存中...",
      "resetToSafe": "重置为安全模式",
      "confirmSaveTitle": "确认风险设置",
      "confirmSaveDesc": "您确定要保存这些风险设置吗？\n\n投资：{{investment}}%\n杠杆：{{leverage}}x\n模式：{{mode}}",
      "confirmSave": "保存设置",
      "saveSuccess": "设置已保存",
      "saveSuccessDesc": "您的风险管理设置已成功保存。",
      "saveError": "保存失败",
      "tradingStrategy": "交易策略",
      "strategyActive": "标准策略",
      "strategyConservative": "神经AI策略",
      "strategyActiveBadge": "推荐",
      "strategyActiveDesc": "基于ML价格预测的较高频交易。每天生成3-8个信号，预期准确率75%-80%。适合希望获得更多机会并能应对中等频率的交易者。",
      "strategyConservativeDesc": "更少但更高置信度的交易，带有严格确认。每天生成1-3个信号，预期准确率85%-90%。适合偏好质量而非数量的保守型交易者。",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "启用 Grid Trading",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "启用 Trailing Stop",
      "signalsPerDay": "每日信号数",
      "expectedAccuracy": "预期准确率",
      "tradeFrequency": "交易频率",
      "riskLevel": "风险水平",
      "profitPotential": "盈利潜力",
      "bestFor": "最适合",
      "activeTraders": "想要更多机会的积极交易者",
      "conservativeTraders": "偏好质量而非数量的保守交易者",
      "high": "高",
      "low": "低",
      "moderate": "中等",
      "higher": "更高",
      "viewComparison": "查看比较",
      "hideComparison": "隐藏比较",
      "testForecastStrategy": "测试预测策略",
      "testingStrategy": "正在测试策略...",
      "testStrategyDesc": "点击测试预测策略是否会立即开仓",
      "paperSettingsError": "模拟设置错误",
      "paperSettingsErrorDesc": "加载模拟交易风险设置失败。",
      "settingsLoadError": "设置加载错误",
      "settingsLoadErrorDesc": "加载风险设置失败。请刷新页面。",
      "configurationRequired": "需要配置",
      "configurationRequiredDesc": "请在测试策略前将投资百分比设置为0%以上。",
      "noTradeSignal": "无交易信号",
      "noTradeSignalDesc": "预测显示移动不足。上涨：{{upward}}%，下跌：{{downward}}%。需要>0.5%才能触发交易。",
      "strategyTestSuccessful": "策略测试成功",
      "strategyTestSuccessfulDesc": "检测到{{direction}}信号，潜在移动{{movement}}%。{{result}}",
      "paperTradeOpened": "模拟交易成功开启！",
      "tradeSimulationCompleted": "交易模拟完成。",
      "strategyTestFailed": "策略测试失败",
      "strategyTestFailedDesc": "策略测试期间发生未知错误。",
      "strategyTestError": "策略测试错误",
      "strategyTestErrorDesc": "测试预测策略失败。",
    },
    "activePositions": {
      "title": "活跃持仓",
      "tabs": {
        "all": "全部",
        "app": "应用",
        "external": "外部",
      },
      "refresh": "刷新",
      "errorLoading": "加载活跃持仓错误",
      "retry": "重试",
      "noPositions": "无活跃持仓。",
      "noPositionsDesc": "一旦您开始交易或启用自动交易，您的活跃交易持仓将显示在这里。",
      "noAppPositions": "无活跃应用持仓。",
      "noExternalPositions": "无活跃外部持仓。",
      "addCredentialsWarning": " 添加API凭证以查看外部持仓",
      "externalError": "❌ 外部持仓错误: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "应用: {{app}} | 外部: {{external},",
      "fields": {
        "size": "大小",
        "entryPrice": "入场价格",
        "currentPrice": "当前价格",
        "margin": "保证金",
        "liquidationPrice": "清算价格",
        "marginRate": "保证金率",
        "takeProfit": "止盈",
        "stopLoss": "止损",
        "roi": "投资回报率",
        "none": "无",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "应用持仓",
        "externalPositions": "外部持仓",
      },
      "headers": {
        "symbol": "交易对",
        "size": "数量",
        "entryPrice": "入场价格",
        "markPrice": "标记价格",
        "liqPrice": "强平价格",
        "margin": "保证金",
        "pnlRoi": "盈亏 (ROI %)",
        "tpSl": "止盈/止损",
        "actions": "操作",
      },
      "close": "平仓",
      "closing": "平仓中...",
      "featureNotAvailable": "功能不可用",
      "positionClosingPaperOnly": "平仓功能目前仅在模拟交易模式下可用。",
      "tpSlPaperOnly": "止盈/止损功能目前仅在模拟交易模式下可用。",
      "positionClosed": "持仓已平仓",
      "positionClosedDesc": "持仓成功平仓。盈亏：${{pnl}}",
      "errorClosingPosition": "平仓错误",
      "errorClosingPositionDesc": "平仓失败",
      "takeProfitSet": "止盈已设置",
      "takeProfitSetDesc": "止盈设置为${{price}}",
      "errorSettingTakeProfit": "设置止盈错误",
      "errorSettingTakeProfitDesc": "设置止盈失败",
      "stopLossSet": "止损已设置",
      "stopLossSetDesc": "止损设置为${{price}}",
      "errorSettingStopLoss": "设置止损错误",
      "errorSettingStopLossDesc": "设置止损失败",
      "position": "持仓",
      "positions": "持仓",
      "allPositions": "所有持仓",
      "noApiCredentials": "未连接API凭证",
    },
    "debug": {
      "testSuccessful": "调试交易测试成功",
      "paperTradeOpened": "模拟交易成功开启！",
      "tradeSimulationCompleted": "交易模拟完成。",
      "testFailed": "调试交易测试失败",
      "unknownError": "调试交易测试期间发生未知错误。",
      "testError": "调试测试错误",
      "testErrorDesc": "测试交易开启失败。",
    },
    "profitShare": {
      "title": "利润分成跟踪",
      "loading": "加载利润分成数据中...",
      "noData": "无可用利润分成数据。开始交易以跟踪您的利润。",
      "balanceOverview": "余额概览",
      "initialBalance": "初始余额:",
      "currentBalance": "当前余额:",
      "netDeposits": "净存款:",
      "profitAnalysis": "利润分析",
      "tradingProfit": "交易利润:",
      "trueProfit": "真实利润:",
      "profitPercentage": "利润百分比:",
      "profitShareInfo": "利润分成",
      "tierRate": "等级{{tier}}费率:",
      "amountOwed": "应付金额:",
      "status": "状态:",
      "profitable": "账户盈利 - 利润分成适用于超过初始余额的收益",
      "notProfitable": "账户尚未盈利 - 在余额超过初始+存款之前无利润分成",
      "profitableDescription": "您的余额已超过初始资金和存款。利润分成费用将根据上方显示的收益计算。",
      "notProfitableDescription": "继续交易以超过初始资金和存款。在此之前无需支付利润分成。",
      "paymentRequired": "需要付款",
      "paymentDescription": "您有${{amount}}的利润分成费用需要支付。",
      "payNow": "立即支付",
      "viewDetails": "查看利润分成详情",
    },
    "tradingHistory": {
      "title": "交易历史（仅应用交易）",
      "description": "显示由DeepTrade平台发起的交易",
      "loading": "加载中...",
      "headers": {
        "date": "日期",
        "symbol": "符号",
        "side": "方向",
        "size": "大小",
        "entry": "入场",
        "exit": "出场",
        "fees": "手续费",
        "pnl": "总盈亏",
        "status": "状态",
      },
      "noHistory": "未找到交易历史。开始交易以在此查看您的历史记录。",
      "pagination": "第{{page}}页，共{{pages}}页（总计{{total}}笔交易）",
      "previous": "上一页",
      "next": "下一页",
    },
    "blockedUser": {
      "title": "交易已阻止:",
      "message": "您的等级（{{tier}}）有未支付的利润分成。欠款: ${{owed}}。请结清余额以继续。",
    },
    "tooltips": {
      "balance": "来自您连接的交易所的当前账户余额。",
      "pnlToday": "今日已平仓交易的已实现盈亏。",
      "monthlyRate": "您的月度回报率百分比。",
      "winRate": "您盈利交易的百分比。"
    }
  },
  "trading": {
    "title": "交易",
    "signals": "信号",
    "positions": "持仓",
    "history": "历史",
    "long": "多头",
    "short": "空头",
    "autoTrading": "自动交易",
    "autoTradingActive": "自动交易激活",
    "autoTradingDisabled": "自动交易禁用",
    "autoTradingActiveDesc": "信号将自动执行",
    "autoTradingDisabledDesc": "启用以自动执行交易信号",
    "noActiveSignals": "无活跃信号",
    "waitingForSignals": "等待新的交易机会...",
    "enableAutoTrading": "启用自动交易以接收信号",
    "refreshSignals": "刷新信号",
    "noOpenPositions": "无开仓",
    "positionsDesc": "您的活跃交易持仓将显示在这里",
    "noTradingHistory": "无交易历史",
    "historyDesc": "您的已完成交易将显示在这里",
    "executeTradeButton": "执行交易",
    "viewDetailsButton": "查看详情",
    "entry": "入场",
    "stopLoss": "止损",
    "takeProfit": "止盈",
    "confidence": "{{value}}% 置信度",
    "strategy": "策略",
    "firstTp": "第一止盈",
    "secondTp": "第二止盈",
    "autoMoveStopLoss": "第一止盈后自动将止损移至盈亏平衡点",
    "tradingMode": "交易模式",
    "paperMode": "模拟",
    "liveMode": "实盘",
    "paperTradingActive": "模拟交易激活",
    "liveTradingActive": "实盘交易激活",
    "paperTradingDesc": "使用虚拟资金练习交易",
    "liveTradingDesc": "使用真实资金交易",
    "virtualBalance": "虚拟余额",
    "unrealizedPnL": "未实现盈亏",
    "equity": "净值",
    "paperTradingHelp": "模拟交易帮助",
    "resetAccount": "重置账户",
    "paperTradingGuide": "模拟交易指南",
    "paperModeTitle": "模拟模式",
    "noProfitSharePaper": "模拟模式无利润分成",
    "paperTradingPositions": "总持仓:",
    "paperTradingHistory": "模拟交易历史",
    "simulatedTradingHistory": "模拟交易历史",
    "noPaperPositions": "无模拟交易持仓",
    "enableAutoTradingPaper": "模拟交易将根据市场信号自动生成模拟持仓",
    "paperTradingMode": "模拟交易模式",
    "autoTradingNotAvailable": "自动交易不可用",
    "autoTradingDisabledPaper": "自动交易控制实盘交易。模拟交易自动生成信号。",
    "riskManagement": "风险管理",
    "riskSettings": "风险设置",
    "investmentPercentage": "投资百分比",
    "leverage": "杠杆",
    "maxLeverage": "最大杠杆",
    "currentTier": "当前等级",
    "exchange": "交易所",
    "accountType": "账户类型",
    "marketType": "市场类型",
    "saveSettings": "保存设置",
    "resetToSafe": "重置为安全",
    "saving": "保存中...",
    "riskSettingsSaved": "风险设置保存成功",
    "failedToSaveRiskSettings": "保存风险设置失败",
    "position": "持仓",
    "internal": "内部",
    "external": "外部",
    "marketClose": "市价平仓",
    "reverse": "反向",
    "editTpSl": "止盈/止损",
    "refreshActivePositions": "刷新活跃持仓",
    "youHaveNoPosition": "您没有持仓。",
    "noActiveAppPositions": "未找到活跃的应用持仓。",
    "noActiveExternalPositions": "未找到活跃的外部持仓。",
    "yourActivePositionsWillAppear": "您的活跃交易持仓将显示在这里。",
    "previous": "上一页",
    "next": "下一页",
    "learnMore": "了解更多",
    "paperTradingLabel": "模拟交易",
    "recentPaperTrades": "最近模拟交易",
    "noPaperTrades": "暂无模拟交易",
    "paperTradingAutoGenerate": "模拟交易将根据市场信号自动生成模拟交易",
    "activePositionsTitle": "活跃持仓",
    "youHaveNoPositions": "您没有持仓。",
    "yourActivePositionsWillAppearHere": "开始交易或启用自动交易后，您的活跃交易持仓将显示在这里。",
    "max": "最大",
    "tooltips": {
      "virtualBalance": "您从已平仓交易中实现的余额。计算方式：初始余额 + 所有已平仓交易的净盈亏总和。",
      "unrealizedPnL": "您当前持仓的盈利或亏损。此值根据当前市场价格实时变化，尚未实现。",
      "equity": "包括持仓在内的总账户价值。计算方式：虚拟余额 + 未实现盈亏。这代表您在模拟交易中的当前净值。",
      "profitAndLoss": "仅来自已平仓交易的已实现盈亏。不包括持仓的未实现盈亏。",
      "balance": "您可用于交易的当前账户余额。",
      "pnlToday": "今日已平仓交易的已实现盈亏。",
      "monthlyRate": "以初始余额百分比计算的月度回报率。",
      "winRate": "盈利的已平仓交易百分比。仅从已完成的交易计算。",
      "totalReturn": "基于虚拟余额的总回报率百分比。计算方式：(当前虚拟余额 - 初始余额) / 初始余额 × 100%。"
    }
  },
  "common": {
    "loading": "加载中...",
    "error": "错误",
    "success": "成功",
    "save": "保存",
    "cancel": "取消",
    "yes": "是",
    "no": "否",
    "active": "活跃",
    "inactive": "非活跃",
    "on": "开",
    "off": "关",
    "enabled": "已启用",
    "disabled": "已禁用",
    "for": "为",
    "warning": "Warning",
    "info": "信息",
    "confirm": "确认",
    "edit": "Edit",
    "delete": "Delete",
    "close": "关闭",
    "back": "返回",
    "next": "下一个",
    "previous": "上一个",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "启用",
    "disable": "禁用",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "确定",
    "apply": "应用",
    "clear": "清除",
    "select": "选择",
    "upload": "上传",
    "download": "下载",
    "copy": "复制",
    "copied": "已复制！",
    "share": "Share",
    "print": "打印",
    "export": "Export",
    "import": "Import",
    "and": "和"  },
  "wallet": {
    "connect": "连接钱包",
    "disconnect": "断开连接",
    "connected": "已连接",
    "notConnected": "未连接",
    "connecting": "连接中...",
    "balance": "余额",
    "address": "地址",
    "solanaBlockchain": "由Solana区块链驱动",
    "solanaTooltip": "基于Solana构建 - 快速、安全、可扩展的区块链",
    "wrongNetwork": "错误网络",
    "switchNetwork": "切换网络",
    "transactionPending": "交易待处理",
    "transactionConfirmed": "交易已确认",
    "transactionFailed": "交易失败",
    "connectionError": "连接错误",
    "connectionFailed": "钱包连接失败",
    "connectionRejected": "钱包连接被拒绝",
    "walletNotFound": "未找到Solana钱包。请安装Phantom等钱包。",
    "disconnected": "钱包已断开",
    "disconnectedSuccess": "您的钱包已成功断开连接。",
    "disconnectError": "断开连接错误",
    "disconnectFailed": "钱包断开连接失败。",
    "confirmDisconnect": "确认断开钱包连接",
    "confirmDisconnectMessage": "您确定要断开钱包连接吗？",
  },
  "notifications": {
    "autoTradingEnabled": "自动交易已启用",
    "autoTradingDisabled": "自动交易已禁用",
    "settingsSaved": "设置已成功保存",
    "passwordChanged": "密码已成功更改",
    "profileUpdated": "个人资料已成功更新",
    "walletConnected": "钱包已成功连接",
    "walletDisconnected": "钱包已断开连接",
    "signalExecuted": "交易信号已执行",
    "tradeCompleted": "交易已成功完成",
    "paymentSuccessful": "付款已成功处理",
    "tierUpgraded": "等级已成功升级",
    "autoTrading": {
      "enabledTitle": "自动交易已启用",
      "enabledDescription": "自动交易已成功启用。余额要求已验证。",
      "disabledTitle": "自动交易已禁用",
      "disabledDescription": "自动交易已成功禁用。",
      "insufficientBalanceTitle": "余额不足",
      "insufficientBalanceDescription": "需要最低{{required}} USDT余额。您当前余额为{{current}} USDT。",
      "missingCredentialsTitle": "缺少API凭证",
      "missingCredentialsDescription": "请先添加并验证您的交易所API凭证。",
      "balanceVerificationFailedTitle": "余额验证失败",
      "balanceVerificationFailedDescription": "无法验证账户余额。请检查您的API凭证。",
      "errorTitle": "自动交易错误",
      "errorDescription": "切换自动交易失败。请重试。",
      "systemDisabledTitle": "自动交易已禁用",
      "noApiCredentialsReason": "未配置交易所API凭证。请添加您的API密钥。",
      "investmentPercentageReason": "投资百分比设置为0%。请调整您的风险设置。",
    },
    "paperAutoTrading": {
      "enabledTitle": "模拟自动交易已启用",
      "enabledDescription": "模拟交易信号现在将自动执行",
      "disabledTitle": "模拟自动交易已禁用",
      "disabledDescription": "模拟交易信号将不再自动执行",
      "errorTitle": "模拟自动交易错误",
      "errorDescription": "切换模拟自动交易失败"
    }
  },
  "errors": {
    "generic": "出现问题。请重试。",
    "network": "网络错误。请检查您的连接。",
    "unauthorized": "您无权执行此操作。",
    "forbidden": "访问被拒绝。",
    "notFound": "未找到请求的资源。",
    "serverError": "服务器错误。请稍后重试。",
    "validationError": "请检查您的输入并重试。",
    "walletNotConnected": "请先连接您的钱包。",
    "insufficientBalance": "余额不足。",
    "transactionFailed": "交易失败。请重试。",
    "apiError": "API错误。如果问题持续存在，请联系支持。",
  },
  "settings": {
    "title": "账户设置",
    "pleaseLogIn": "请登录",
    "loginRequired": "您需要登录才能访问账户设置。",
    "goToLogin": "前往登录",
    "profile": {
      "title": "个人资料设置",
      "description": "管理您的账户信息和设置",
      "email": "邮箱地址",
      "currentEmail": "当前邮箱",
      "newEmail": "新邮箱地址",
      "updateEmail": "更新邮箱",
      "sending": "发送中...",
      "placeholders": {
        "newEmail": "输入您的新邮箱地址",
        "currentPassword": "输入您的当前密码"
      }
    },
    "security": {
      "title": "安全设置",
      "description": "管理您的密码和安全设置",
      "changePassword": "更改密码",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmPassword": "确认新密码",
      "enable2FA": "双因素身份验证",
      "twoFactorEnabled": "您的账户已启用双因素身份验证",
      "twoFactorDisabled": "您的账户已禁用双因素身份验证",
      "changing": "更改中...",
      "changePasswordButton": "更改密码",
      "verificationCode": "验证码",
      "verifyCode": "验证码",
      "verifying": "验证中...",
      "cancel": "取消",
      "disable2FA": "禁用双因素身份验证",
      "disable2FADescription": "您确定要禁用2FA吗？这将使您的账户安全性降低。我们将向您的邮箱发送验证码以确认此操作。",
      "sendVerificationCode": "发送验证码",
      "disabling": "禁用中...",
      "disable2FAButton": "禁用2FA",
      "resendCode": "重新发送验证码",
      "verifyEmail": "验证您的邮箱",
      "verifyEmailDescription": "我们已向您的邮箱发送了6位验证码。请在下方输入以启用2FA。",
      "verifyEmailToDisable2FA": "验证邮箱以禁用2FA",
      "verifyEmailToDisable2FADescription": "我们已向您的邮箱发送了6位验证码。请在下方输入以禁用双因素身份验证。",
      "placeholders": {
        "currentPassword": "输入您的当前密码",
        "newPassword": "输入您的新密码",
        "confirmPassword": "确认您的新密码",
        "verificationCode": "输入6位验证码"
      }
    },
    "account": {
      "title": "危险区域",
      "deleteAccount": "删除账户",
      "deleteAccountWarning": "一旦删除您的账户，就无法恢复。请谨慎操作。",
      "deleteAccountButton": "删除账户",
      "deleting": "删除中...",
      "deleteAccountModal": {
        "title": "删除账户",
        "description": "此操作无法撤销。这将永久删除您的账户并移除所有相关数据。",
        "confirmText": "删除账户",
        "typedConfirmationText": "删除",
        "permanentlyDelete": "这将永久删除：",
        "consequences": [
          "永久删除您的所有数据",
          "移除您的交易历史",
          "取消活跃订阅",
          "移除所有API凭证",
          "删除所有设置和偏好"
        ]
      }
    },
    "errors": {
      "fillAllFields": "请填写所有字段",
      "passwordsNotMatch": "新密码不匹配",
      "invalidVerificationCode": "请输入验证码",
      "invalid6DigitCode": "请输入有效的6位验证码",
      "updateEmailFailed": "更新邮箱失败",
      "changePasswordFailed": "更改密码失败",
      "enable2FAFailed": "启用2FA失败",
      "verify2FAFailed": "验证2FA代码失败",
      "disable2FAFailed": "发送禁用验证码失败",
      "disable2FAVerifyFailed": "禁用2FA失败",
      "deleteAccountFailed": "删除账户失败"
    },
    "success": {
      "verificationEmailSent": "验证邮件已发送",
      "verificationEmailDescription": "请检查{{email}}获取验证说明。",
      "passwordChanged": "密码已更改",
      "passwordChangedDescription": "您的密码已成功更新。",
      "2FACodeSent": "2FA代码已发送",
      "2FACodeSentDescription": "请检查您的邮箱获取验证码。",
      "2FAEnabled": "2FA已启用",
      "2FAEnabledDescription": "双因素身份验证已成功启用。",
      "verificationCodeSent": "验证码已发送",
      "verificationCodeSentDescription": "请检查您的邮箱获取6位验证码以禁用2FA。",
      "2FADisabled": "2FA已禁用",
      "2FADisabledDescription": "双因素身份验证已成功禁用。",
      "accountDeleted": "账户已删除",
      "accountDeletedDescription": "您的账户已成功删除。"
    }
  },
  "accessSecurity": {
    "title": "访问与安全",
    "subtitle": "监控您的账户安全和登录活动",
    "totalLogins": "总登录次数",
    "successRate": "成功率",
    "uniqueIPs": "唯一IP",
    "twoFactorStatus": "双因素认证状态",
    "enabled": "已启用",
    "disabled": "已禁用",
    "currentSession": "当前会话",
    "currentSessionDescription": "关于您当前登录会话的信息",
    "recentLoginActivity": "最近登录活动",
    "recentLoginDescription": "您最近的登录尝试和会话",
    "refresh": "刷新",
    "ipAddress": "IP地址",
    "timestamp": "时间戳",
    "status": "状态",
    "userAgent": "用户代理",
    "successful": "成功",
    "failed": "失败",
    "noLoginActivity": "未找到登录活动",
    "currentDevice": "当前设备",
    "location": "位置",
    "sessionStart": "会话开始",
    "lastLoginActivity": "最后登录活动",
    "lastLoginDescription": "您最近一次成功登录",
    "loginTime": "登录时间",
    "browser": "浏览器",
    "lastThirtyDays": "过去30天",
    "loginSuccessRate": "登录成功率",
    "differentLocations": "不同位置",
    "never": "从未",
    "unknown": "未知",
    "reason": "原因:",
    "authenticationRequired": "需要身份验证",
    "authenticationRequiredDescription": "请登录以查看您的安全信息。",
    "errors": {
      "authenticationError": "身份验证错误",
      "authenticationErrorDescription": "请重新登录以查看安全数据。",
      "networkError": "网络错误",
      "networkErrorDescription": "获取安全数据失败。请检查您的连接。",
      "refreshFailed": "刷新失败",
      "refreshFailedDescription": "刷新安全数据失败。请重试。"
    },
    "success": {
      "dataRefreshed": "安全数据已刷新",
      "dataRefreshedDescription": "您的安全信息已成功更新。"
    }
  },
  "tiers": {
    "title": "等级管理",
    "currentTier": "当前等级",
    "choosePlan": "选择您的计划",
    "tier1": {
      "name": "等级1",
      "subtitle": "免费",
      "description": "适合基础交易信号入门",
      "features": [
        "基础交易信号",
        "手动交易执行",
        "社区支持",
        "基础市场分析"
      ]
    },
    "tier2": {
      "name": "等级2",
      "subtitle": "30天访问",
      "description": "为认真交易者提供的高级功能",
      "features": [
        "高级AI交易信号",
        "自动交易功能",
        "优先支持",
        "高级分析",
        "风险管理工具"
      ]
    },
    "tier3": {
      "name": "等级3",
      "subtitle": "需要NFT",
      "description": "具有独家功能的高级等级",
      "features": [
        "高级交易信号",
        "高级自动交易",
        "VIP支持",
        "独家市场洞察",
        "自定义策略"
      ]
    },
    "activate": "激活",
    "current": "当前",
    "paymentRequired": "需要付款",
    "nftRequired": "需要NFT",
    "membershipStatus": "会员状态",
    "active": "活跃",
    "expired": "已过期",
    "daysRemaining": "剩余天数",
    "expiresOn": "到期日",
  },
  "apiCredentials": {
    "title": "API凭证",
    "description": "管理您的交易所API凭证进行交易",
    "addCredentials": "添加API凭证",
    "exchange": "交易所",
    "exchanger": "交易商",
    "apiKey": "API密钥",
    "apiSecret": "API密钥",
    "secretKey": "密钥",
    "passphrase": "密码短语",
    "testConnection": "测试连接",
    "save": "保存凭证",
    "edit": "编辑",
    "delete": "删除",
    "status": "状态",
    "connected": "已连接",
    "disconnected": "已断开",
    "invalid": "无效",
    "active": "活跃",
    "testing": "测试中...",
    "connectionSuccess": "连接成功",
    "connectionFailed": "连接失败",
    "credentialsAdded": "API凭证已成功添加",
    "credentialsUpdated": "API凭证已成功更新",
    "credentialsDeleted": "API凭证已成功删除",
    "connectedTo": "已连接到",
    "connectionNeedsAttention": "连接到",
    "needsAttention": "需要注意",
    "lastUpdated": "最后更新",
    "disconnect": "断开连接",
    "disconnecting": "断开连接中...",
    "setAsActive": "设为活跃",
    "activating": "激活中...",
    "autoTrading": "自动交易",
    "enableAutoTradingDesc": "为此交易所启用自动交易",
    "add": "添加",
    "update": "更新",
    "connectionValidated": "连接已验证！",
    "autoTradingStatusChanged": "自动交易已",
    "credentialAddedLimitReached": "凭证已添加（已达限制）",
    "updateCredentialsMessage": "请更新您的API凭证以继续交易",
    "tier2LimitReached": "二级限制已达到：最多允许两个CEX凭证。",
    "requiredMarketType": "所需市场类型",
    "marketTypes": {
      "futures": "期货",
      "spot": "现货",
      "binanceNote": "期货交易 - 最高125倍杠杆可用",
      "binanceUsNote": "保证金现货交易 - 最高3倍杠杆可用",
      "krakenNote": "期货交易 - 最高100倍杠杆可用",
      "bybitNote": "期货交易 - 最高100倍杠杆可用",
      "hyperliquidNote": "永续期货交易 - 最高50倍杠杆可用",
      "standardNote": "标准现货交易",
    },
    "errors": {
      "loadFailed": "加载凭证失败",
      "keysRequired": "需要API密钥和密钥",
      "tierUndetermined": "无法确定用户等级",
      "tier1Limit": "等级1只允许一个API凭证",
      "tier2PerCex": "等级2每个CEX只允许一个凭证",
      "tier2Limit": "等级2最多允许两个凭证（每个CEX一个）",
      "tier3Limit": "等级3所有CEX只允许一个凭证",
      "saveFailed": "保存失败",
      "validationFailed": "验证失败",
      "activationFailed": "激活失败",
      "deactivationFailed": "停用失败",
      "noCredentials": "未找到此交易所的凭证",
      "autoTradingUpdateFailed": "自动交易更新失败",
      "autoTradingUpdateFailedDesc": "无法更新自动交易设置",
    },
    "success": {
      "credentialsSaved": "凭证已保存",
      "connectionSuccessful": "连接成功",
      "activated": "已激活",
      "deactivated": "已停用",
      "autoTradingEnabled": "自动交易已启用",
      "autoTradingDisabled": "自动交易已禁用",
    }
  },
  "referrals": {
    "title": "推荐仪表板",
    "loading": "正在加载推荐仪表板...",
    "referralLink": "推荐链接",
    "referralLinkDescription": "分享此链接以从您推荐人的利润分享付款中赚取{{rate}}%。",
    "tierNames": {
      "tier1": "等级1",
      "tier2": "等级2",
      "tier3": "等级3"
    },
    "settings": {
      "title": "设置",
      "referralSettings": "推荐设置",
      "solanaWalletAddress": "Solana钱包地址",
      "walletPlaceholder": "输入您的Solana钱包地址以接收付款",
      "minimumPayoutAmount": "最低支付金额 ($)",
      "enableAutomaticPayments": "启用自动支付",
      "autoPaymentEnabled": "启用后，您将在推荐付款到期时自动收到付款。",
      "autoPaymentDisabled": "禁用后，您将不会收到任何推荐付款，直到再次启用此功能。",
      "saveSettings": "保存设置",
      "importantWarning": "重要警告:",
      "warnings": {
        "ensureCorrectAddress": "请确保您的Solana钱包地址正确",
        "doubleCheckAddress": "保存前请再次检查地址",
        "notResponsible": "DeepTrade对发送到错误或无效地址的付款不承担责任",
        "cannotRecover": "由于地址错误而丢失的资金无法恢复"
      },
      "minimumPayoutRequirements": "最低支付要求:",
      "requirements": {
        "minimumAmount": "最低支付金额: $10.00 USDT",
        "gasFeeDeducted": "Solana网络燃气费将从支付中扣除",
        "estimatedGasFee": "预估燃气费: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "支付在Solana网络上以USDT处理"
      }
    },
    "overview": {
      "totalReferrals": "总推荐数",
      "activeCount": "{{count}}个活跃",
      "totalEarnings": "总收益",
      "totalPaid": "${{amount}}已支付",
      "pendingPayout": "待支付",
      "requestPayout": "请求支付",
      "earningRate": "收益率"
    },
    "actions": {
      "copy": "复制",
      "generateNew": "生成新的"
    },
    "recentActivity": {
      "recentReferrals": "最近推荐",
      "recentEarnings": "最近收益",
      "noReferrals": "暂无推荐。开始分享您的链接吧！",
      "noEarnings": "暂无收益。推荐人需要开始交易！",
      "earned": "${{amount}}已赚取"
    },
    "status": {
      "verified": "已验证",
      "pending": "待处理",
      "paid": "已支付"
    },
    "messages": {
      "copied": "已复制！",
      "linkCopied": "推荐链接已复制到剪贴板",
      "newCodeGenerated": "新推荐代码已生成",
      "profileUpdated": "个人资料更新成功",
      "payoutRequestSubmitted": "支付请求已提交"
    },
    "errors": {
      "failedToLoadData": "加载推荐数据失败",
      "failedToGenerateCode": "生成新代码失败",
      "invalidMinimumPayout": "无效的最低支付额",
      "minimumPayoutRequired": "最低支付额必须至少为$10.00",
      "invalidWalletAddress": "无效的钱包地址",
      "validWalletRequired": "请输入有效的Solana钱包地址",
      "failedToUpdateProfile": "更新个人资料失败",
      "failedToRequestPayout": "请求支付失败"
    }
  },

  "paperTradingHelp": {
    "title": "模拟交易指南",
    "whatIsPaperTrading": "什么是模拟交易？",
    "whatIsPaperTradingDesc": "模拟交易是一个模拟交易环境，允许您使用虚拟资金而非真实资金来练习交易策略。这是在没有任何财务风险的情况下测试我们AI交易系统的完美方式。",
    "keyBenefits": "主要优势",
    "riskFree": "无风险学习",
    "riskFreeDesc": "使用虚拟资金练习 - 无真实资金风险",
    "realMarketData": "真实市场数据",
    "realMarketDataDesc": "体验实时市场条件和价格波动",
    "aiTradingSystem": "AI交易系统",
    "aiTradingSystemDesc": "在安全环境中测试我们的高级AI信号",
    "buildConfidence": "建立信心",
    "buildConfidenceDesc": "在使用真实资金之前培养您的交易技能",
    "howItWorks": "工作原理",
    "step1": "切换到模拟模式",
    "step1Desc": "切换交易模式开关以启用模拟交易",
    "step2": "虚拟余额",
    "step2Desc": "从$10,000虚拟余额开始（可重置）",
    "step3": "AI信号",
    "step3Desc": "我们的AI基于真实市场数据生成交易信号",
    "step4": "模拟交易",
    "step4Desc": "交易虚拟执行 - 跟踪您的表现",
    "importantNotes": "重要说明",
    "noRealMoney": "无真实资金",
    "noRealMoneyDesc": "模拟交易仅使用虚拟资金。不会产生真实的盈利或亏损。",
    "noRealFees": "无真实费用",
    "noRealFeesDesc": "交易费用和滑点被模拟以提供真实体验。",
    "performanceTracking": "表现跟踪",
    "performanceTrackingDesc": "所有统计和分析仅基于模拟交易。",
    "readyToStart": "准备开始了吗？",
    "readyToStartDesc": "将\"交易模式\"开关切换到\"模拟\"，今天就开始使用虚拟资金练习！",
    "buildConfidenceFooter": "💪 在冒险使用真实资金之前，通过模拟交易建立信心！",
    "resetModal": {
      "title": "重置模拟交易账户",
      "warning": "警告：此操作无法撤销",
      "warningDesc": "这将永久删除您的所有模拟交易历史并重置您的虚拟余额。",
      "resetLimitReached": "达到每日重置限制",
      "resetLimitReachedDesc": "您已用完今天的3次重置。限制将在UTC午夜重置。",
      "resetsRemaining": "今天剩余重置次数：{{count},",
      "currentBalance": "当前余额：${{balance},",
      "resetToDefault": "重置为默认$10,000",
      "customBalance": "设置自定义余额",
      "customBalanceDesc": "输入自定义起始余额（最低$1,000）",
      "confirmationRequired": "输入'RESET'确认",
      "confirmationPlaceholder": "在此输入RESET...",
      "confirmationRequiredError": "请输入'RESET'确认",
      "invalidBalance": "无效余额",
      "invalidBalanceDesc": "请输入有效的正余额金额",
      "resetting": "重置中...",
      "resetButton": "重置账户",
    },
    "howItWorksModal": {
      "title": "模拟交易工作原理",
      "step1": "从$10,000虚拟余额开始（可配置）",
      "step2": "启用自动交易让AI自动执行交易",
      "step3": "监控表现并根据需要调整风险设置",
      "step4": "对系统有信心时切换到实盘交易",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "无真实资金：",
      "noRealMoneyDesc": "模拟交易仅使用虚拟资金。不会产生真实的盈利或亏损。",
      "noFeesTitle": "无费用：",
      "noFeesDesc": "模拟交易不会产生利润分成费用，因为没有真实利润产生。",
      "resetLimitTitle": "重置限制：",
      "resetLimitDesc": "您每天最多可以重置模拟账户3次。",
    },
    "benefits": {
      "title": "模拟交易的好处",
      "riskFreeLearning": "无风险学习",
      "riskFreeLearningDesc": "在学习我们的AI系统工作原理的同时，无需损失真实资金即可练习",
      "strategyTesting": "策略测试",
      "strategyTestingDesc": "测试不同的风险设置，看看它们随时间的表现如何",
      "realMarketData": "真实市场数据",
      "realMarketDataDesc": "使用实时市场价格和真实的ML预测，提供真实的体验",
    },
    "gettingStarted": {
      "title": "准备开始了吗？",
      "description": "将\"交易模式\"开关切换到\"模拟\"，今天就开始使用虚拟资金练习！",
      "buildConfidenceFooter": "💪 在冒险使用真实资金之前，通过模拟交易建立信心！",
    },
    "perfectForBeginners": "💡 非常适合想要测试新策略的初学者和经验丰富的交易者！",
    "availableToAllTitle": "所有用户可用：",
    "availableToAllDesc": "模拟交易适用于所有用户，无论其等级水平如何。",
    "gotItThanks": "明白了，谢谢！",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "模拟交易表现",
      "refresh": "刷新",
      "reset": "重置",
      "totalReturn": "总回报",
    },

    "errors": {
      "loadFailed": "加载模拟交易数据失败",
    }
  },
  "tradingSignalStatus": {
    "title": "交易信号状态",
    "description": "来自全系统信号广播的实时状态",
    "signalLabel": "信号",
    "confidenceLabel": "AI信号置信度",
    "lastUpdateLabel": "最后更新",
    "errorLoading": "加载交易状态失败",
    "signals": {
      "HOLD": "持有",
      "BUY": "买入",
      "SELL": "卖出",
      "LONG": "做多",
      "SHORT": "做空",
      "long": "做多",
      "short": "做空"
    }
  },
  "pagination": {
    "show": "显示:",
    "perPage": "每页",
    "showing": "显示第{{start}}到{{end}}项，共{{total}}项"
  },
  "tier": {
    "choosePlan": "选择计划",
    "membershipStatus": {
      "title": "会员状态",
      "active": "活跃",
      "expired": "已过期",
      "daysRemaining": "剩余天数:",
      "expiresOn": "到期时间:"
    },
    "modals": {
      "activateTier": "激活{{tierName}}等级",
      "confirmActivation": "您确定要激活{{tierName}}等级吗？",
      "confirmTierChange": "确认等级变更",
      "confirmSwitch": "您确定要切换到{{tierName}}等级吗？",
      "cancel": "取消",
      "activate": "激活",
      "confirm": "确认"
    },
    "tiers": {
      "starter": {
        "name": "等级1: 入门版",
        "price": "免费",
        "description": "开始使用的完美选择",
        "features": [
          "基础交易信号",
          "最高2.5倍交易杠杆",
          "限制一个API访问",
          "40%利润分成费用"
        ]
      },
      "pro": {
        "name": "等级2: 专业版",
        "description": "为认真的交易者设计",
        "accessInstructions": "要访问此等级，请使用顶部导航栏的钱包按钮连接您的Solana钱包并支付30天访问费用。",
        "features": [
          "高级交易信号",
          "最高5倍交易杠杆",
          "限制两个API访问",
          "20%利润分成费用"
        ]
      },
      "nftElite": {
        "name": "等级3: NFT精英版",
        "price": "终身",
        "description": "为经过验证的Capitolchilax NFT收藏者设计。",
        "visitWebsite": "访问capitolchilax.com",
        "accessInstructions": "要访问此等级，请使用顶部导航栏的钱包按钮连接并验证您的NFT资格。",
        "features": [
          "高级交易信号",
          "最高10倍交易杠杆",
          "无限API连接",
          "10%利润分成费用",
          "无月度会员费"
        ]
      }
    },
    "status": {
      "currentTier": "当前等级",
      "alreadyUnlocked": "已解锁",
      "yourCurrentTier": "您的当前等级",
      "currentlyOn": "您当前使用的是{{tierName}}"
    },
    "buttons": {
      "paymentRequired": "需要付款",
      "connectWallet": "连接钱包",
      "nftRequired": "需要NFT",
      "select": "选择{{tierName}}",
      "activate": "激活{{tierName}}",
      "payWithToken": "用{{token}}支付",
      "payToReactivate": "付款重新激活",
      "connectWalletFirst": "请先连接钱包",
      "proceedWithPayment": "继续付款"
    },
    "pricing": {
      "free": "免费",
      "lifetime": "终身",
      "thirtyDayAccess": "30天访问: {{price}}"
    },
    "profitShare": {
      "status": "利润分成状态",
      "paymentDue": "付款到期",
      "accountDisabled": "账户已禁用",
      "accountTradingDisabled": "账户交易已禁用",
      "accountDisabledDescription": "由于未支付的利润分成费用${{amount}}，您的账户已被禁用。",
      "deadlineApproaching": "截止日期临近",
      "deadlineMessage": "利润分成付款${{amount}}的截止日期即将到来。",
      "deadline": "截止日期:",
      "payNow": "立即支付",
      "youOwe": "您欠款: {{amount}}",
      "allCaughtUp": "全部完成！",
      "accountSuspendedWarning": "您的账户已被暂停。请完成付款以恢复交易。",
      "disabledOn": "禁用日期:",
      "paymentWasDue": "付款到期日:",
      "nextPaymentDeadline": "下次付款截止日期:",
      "scheduleInfo": "利润分成付款每周六GMT 0:00到期",
      "disableWarning": "账户将因未付费用在每周六GMT 0:00被禁用",
      "accountDisabledMessage": "账户已被禁用。请完成付款以恢复交易。",
      "paymentOverdue": "付款逾期",
      "paymentDueSoon": "付款即将到期",
      "wasDue": "到期日:",
      "due": "到期:",
      "overdue": "逾期",
      "noPendingFees": "没有待付的利润分成费用 - 全部完成！🎉"
    },
    "payment": {
      "thirtyDaysAccess": "30天访问",
      "thirtyDaysAccessDescription": "需要支付30天高级访问费用",
      "thirtyDaysAccessDue": "30天访问费用到期",
      "paymentDetails": "付款详情",
      "amount": "金额",
      "network": "网络",
      "wallet": "钱包",
      "connectionStatus": "连接状态",
      "connected": "已连接",
      "disconnected": "未连接",
      "importantNotes": "重要提示",
      "paymentWarnings": [
        "仅接受{{token}}代币",
        "付款不可退款",
        "请等待交易确认",
        "付款后访问权限将自动激活"
      ],
      "processing": "处理中",
      "processingDescription": "正在处理您的付款。请稍候...",
      "successful": "成功",
      "successDescription": "您的付款已成功处理！",
      "failed": "失败",
      "failedDescription": "处理您的付款时出现错误。请重试。",
      "tryAgain": "重试"
    },
    "paymentHistory": {
      "title": "付款历史",
      "profitShare": "利润分成",
      "thirtyDaysAccess": "30天访问",
      "billingPeriod": "${{amount}} - {{startDate}}至{{endDate}}"
    },
    "nft": {
      "verifyingOwnership": "正在验证NFT所有权...",
      "nftRequired": "此等级需要NFT",
      "nftOwned": "NFT已验证 ✓"
    },
    "coupon": {
      "haveACoupon": "有优惠券？在此兑换",
      "upgradeInstantly": "使用优惠券代码立即升级您的等级",
      "redeemButton": "兑换优惠券",
      "redeemDescription": "使用优惠券代码立即升级等级"
    },
    "errors": {
      "paymentRequired": "需要付款",
      "activationFailed": "激活失败",
      "membershipExpiredTitle": "会员资格已过期",
      "membershipExpired": "您的会员资格已过期。已恢复到等级1。",
      "walletDisconnectedTitle": "钱包已断开连接",
      "walletDisconnectedWithDays": "钱包已断开连接，但您的会员资格还有{{days}}天有效。",
      "couldNotValidate": "无法验证会员资格。保持当前等级。",
      "walletDisconnected": "钱包已断开连接。",
      "downgradeNotAllowedTitle": "不允许降级",
      "downgradeNotAllowed": "无法从等级{{currentTier}}降级到等级{{newTier}}。",
      "walletConnectionRequiredTitle": "需要连接钱包",
      "walletConnectionRequired": "访问此等级需要连接Solana钱包。",
      "nftRequired": "此等级需要NFT。",
      "failedToFetchTier": "获取等级信息失败",
      "errorLoadingTier": "等级加载错误",
      "walletNotConnectedTitle": "钱包未连接",
      "walletNotConnected": "请连接钱包以进行付款。",
      "dataFetchErrorTitle": "数据获取错误",
      "dataFetchError": "获取数据时出现错误: {{error}}"
    },
    "success": {
      "tierUpdated": "等级已更新为{{tierName}}",
      "tierActivated": "等级已成功激活",
      "paymentSuccessful": "{{type}}付款已成功完成"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 账户已禁用",
        "description": "由于未支付的利润分成费用${{amount}}，您的账户已被禁用。请完成付款以恢复交易。"
      },
      "paymentOverdue": {
        "title": "⚠️ 付款逾期",
        "description": "利润分成付款${{amount}}已逾期。请立即完成付款以避免账户禁用。"
      },
      "paymentReminder": {
        "title": "⏰ 付款提醒",
        "description": "利润分成付款${{amount}}将在周六GMT 0:00到期。请付款以避免账户暂停。"
      }
    }
  },
  "help": {
    "title": "帮助与支持",
    "description": "查找常见问题的答案，查看我们的法律政策，并联系我们的支持团队。",
    "faqTab": "常见问题",
    "legalTab": "法律",
    "contactTab": "联系",
    "faqSection": {
      "categories": {
        "general": "一般",
        "trading": "交易",
        "tiers": "等级",
        "setup": "设置",
        "security": "安全",
        "billing": "计费"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "什么是DeepTrade？",
          "answer": "DeepTrade是一个AI驱动的加密货币交易平台，使用先进的机器学习算法提供自动化交易信号和投资组合管理工具。"
        },
        "howSignalsWork": {
          "question": "交易信号如何工作？",
          "answer": "我们的AI实时分析市场数据，生成包含入场点、止损和止盈水平的买卖信号。您可以手动执行或启用自动交易。"
        },
        "tierLevels": {
          "question": "不同的等级水平是什么？",
          "answer": "等级1（免费）：基础信号。等级2（$50/月）：高级信号+自动交易。等级3（需要NFT）：高级功能+优先支持。"
        },
        "connectExchange": {
          "question": "如何连接我的交易所账户？",
          "answer": "转到仪表板中的API凭据，添加您的交易所API密钥（建议只读），我们的系统将验证连接。"
        },
        "dataSecure": {
          "question": "我的数据安全吗？",
          "answer": "是的，我们使用行业标准加密，从不存储您的私钥，并建议使用只读API访问以获得最大安全性。"
        },
        "profitShares": {
          "question": "利润分成如何工作？",
          "answer": "对于等级2+用户，我们收取通过信号产生的利润的小百分比。这使我们的利益与您的成功保持一致。"
        },
        "cancelSubscription": {
          "question": "我可以随时取消订阅吗？",
          "answer": "是的，您可以随时降级或取消订阅。您将保留访问权限直到当前计费周期结束。"
        },
        "supportedExchanges": {
          "question": "支持哪些交易所？",
          "answer": "我们目前支持主要交易所，包括Binance、Coinbase Pro、Kraken等。请查看我们的API凭据页面获取完整列表。"
        }
      }
    },
    "legal": {
      "documents": "法律文件",
      "englishNotice": "为了法律清晰性，始终以英文显示",
      "privacy": {
        "title": "隐私政策",
        "description": "我们的隐私政策概述了当您使用DeepTrade服务时，我们如何收集、使用和保护您的个人信息。我们致力于维护您数据的隐私和安全。",
        "highlights": {
          "title": "关键隐私要点：",
          "item1": "我们只收集提供服务所需的信息",
          "item2": "您的交易数据经过加密并安全存储",
          "item3": "我们从不向第三方出售您的个人信息",
          "item4": "您可以控制您的数据和隐私设置"
        },
        "viewFull": "查看完整隐私政策"
      },
      "terms": {
        "title": "服务条款",
        "description": "我们的服务条款管理您对DeepTrade平台和服务的使用。通过使用我们的平台，您同意这些条款和条件。",
        "highlights": {
          "title": "关键条款要点：",
          "item1": "平台使用权利和限制",
          "item2": "用户责任和义务",
          "item3": "服务可用性和限制",
          "item4": "账户终止和暂停政策"
        },
        "viewFull": "查看完整服务条款"
      },
      "risks": {
        "title": "风险披露"
      }
    },
    "contact": {
      "title": "联系支持",
      "form": {
        "name": "姓名",
        "email": "邮箱",
        "subject": "主题",
        "message": "消息",
        "sendMessage": "发送消息",
        "sending": "发送中...",
        "placeholders": {
          "name": "您的全名",
          "email": "your.email@example.com",
          "subject": "问题的简要描述",
          "message": "请详细描述您的问题..."
        }
      },
      "guidelines": {
        "title": "支持指南",
        "before": {
          "title": "联系支持前",
          "item1": "首先查看此FAQ部分",
          "item2": "检查您的账户设置",
          "item3": "验证您的API凭据",
          "item4": "查看我们的状态页面了解已知问题"
        },
        "when": {
          "title": "联系支持时",
          "item1": "包含您的账户邮箱",
          "item2": "详细描述问题",
          "item3": "如适用，提供截图",
          "item4": "包含错误消息"
        },
        "notice": {
          "title": "重要通知",
          "message": "我们永远不会要求您的私钥、密码或API密钥。请保护好这些信息，永远不要与任何人分享。"
        }
      },
      "errors": {
        "missingInformation": "信息缺失",
        "fillAllFields": "请在提交前填写所有字段。",
        "failedToSend": "发送消息失败",
        "error": "错误",
        "tryAgainLater": "发送消息失败。请稍后重试。"
      },
      "success": {
        "messageSent": "消息已发送！",
        "thankYou": "感谢您联系我们。我们将在24-48小时内回复您。"
      }
    }
  },
  "redeemCoupon": {
    "title": "兑换优惠券",
    "subtitle": "输入您的优惠券代码以升级等级",
    "currentTier": "当前等级:",
    "couponCode": "优惠券代码",
    "placeholder": "输入优惠券代码 (例如: DTABC123)",
    "formatHint": "代码必须是4-20个字符，仅限字母和数字",
    "redeemButton": "兑换优惠券",
    "redeeming": "兑换中...",
    "backToTier": "← 返回等级管理",
    "tierNames": {
      "starter": "入门版 (免费)",
      "pro": "专业版 (高级)",
      "vip": "VIP (精英)",
      "unknown": "未知"
    },
    "howItWorks": {
      "title": "使用方法:",
      "steps": [
        "在上方输入您的优惠券代码",
        "您的等级将自动升级",
        "您将立即获得新功能的访问权限",
        "每个优惠券只能使用一次"
      ]
    },
    "errors": {
      "invalidInput": "无效输入",
      "enterCouponCode": "请输入优惠券代码",
      "invalidFormat": "无效格式",
      "formatRequirement": "优惠券代码必须是4-20个字符，仅限字母和数字",
      "redemptionFailed": "兑换失败",
      "failedToRedeem": "兑换优惠券失败",
      "networkError": "网络错误",
      "connectionFailed": "连接服务器失败。请重试。"
    },
    "success": {
      "redeemed": "优惠券兑换成功！",
      "validFor": "(有效期{{days}}天)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "身份验证中...",
      "description": "请稍候，我们正在完成您的身份验证。"
    },
    "error": {
      "title": "身份验证错误",
      "returnToLogin": "返回登录",
      "tryAgain": "重试"
    },
    "completing": {
      "title": "完成身份验证",
      "description": "请稍候，我们正在为您登录..."
    },
    "errors": {
      "authenticationFailed": "身份验证失败",
      "noAuthorizationCode": "未从OAuth提供商收到授权码",
      "invalidServerResponse": "服务器响应无效",
      "unexpectedError": "身份验证过程中发生意外错误",
      "noAdditionalDetails": "没有其他详细信息"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "密码必须至少8个字符",
      "uppercase": "密码必须包含至少一个大写字母",
      "lowercase": "密码必须包含至少一个小写字母",
      "number": "密码必须包含至少一个数字",
      "specialChar": "密码必须包含至少一个特殊字符"
    },
    "errors": {
      "invalidToken": "无效令牌",
      "invalidTokenDescription": "此密码重置链接无效或已过期。",
      "validationFailed": "验证失败",
      "validationFailedDescription": "重置令牌验证失败。请重试。",
      "fillAllFields": "请填写所有字段",
      "passwordsDoNotMatch": "密码不匹配",
      "requirementsNotMet": "密码要求未满足",
      "resetFailed": "密码重置失败",
      "resetFailedTitle": "重置失败"
    },
    "success": {
      "title": "密码重置成功",
      "description": "您的密码已成功更新。",
      "passwordUpdated": "✓ 密码已更新",
      "securityNote": "您现在可以使用新密码登录。出于安全考虑，您已从所有设备注销。",
      "continueToLogin": "继续登录"
    },
    "validating": {
      "title": "验证重置链接",
      "description": "请稍候，我们正在验证您的密码重置链接..."
    },
    "invalid": {
      "title": "无效的重置链接",
      "description": "此密码重置链接无效或已过期。",
      "linkInvalid": "链接无效",
      "reason1": "• 重置链接可能已过期（链接在1小时后过期）",
      "reason2": "• 链接可能已被使用",
      "reason3": "• 链接可能格式错误或不完整",
      "requestNewLink": "请求新的重置链接",
      "backToLogin": "返回登录"
    },
    "form": {
      "title": "重置您的密码",
      "description": "为{{email}}输入新密码",
      "newPassword": "新密码",
      "newPasswordPlaceholder": "输入您的新密码",
      "confirmPassword": "确认新密码",
      "confirmPasswordPlaceholder": "确认您的新密码",
      "updating": "正在更新密码...",
      "updateButton": "更新密码",
      "backToLogin": "返回登录"
    },
    "requirements": {
      "title": "密码要求",
      "minLength": "• 至少8个字符",
      "caseLetters": "• 包含大写和小写字母",
      "number": "• 包含至少一个数字",
      "specialChar": "• 包含至少一个特殊字符 (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "此重置链接将于{{time}}过期"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "您最后一次成功交易是什么时候？",
      "question2": "您目前处于哪个等级（1、2或3）？",
      "question3": "您主要使用哪个交易所进行交易？"
    },
    "errors": {
      "fillRequiredFields": "请填写所有必填字段（邮箱、全名和原因）",
      "submitFailed": "提交2FA重置请求失败",
      "requestFailed": "请求失败"
    },
    "success": {
      "requestSubmitted": "请求已提交",
      "title": "请求已提交",
      "description": "您的2FA重置请求已提交审核。",
      "submittedSuccessfully": "✓ 请求提交成功",
      "email": "邮箱",
      "requestId": "请求ID",
      "status": "状态",
      "pendingReview": "待审核",
      "whatHappensNext": "接下来会发生什么？",
      "step1": "1. 我们的安全团队将审核您的请求和验证信息",
      "step2": "2. 如有需要，我们可能会联系您进行额外验证",
      "step3": "3. 处理完成后您将收到邮件通知",
      "step4": "4. 如果获得批准，您的2FA将被禁用，您可以重新设置",
      "backToLogin": "返回登录",
      "submitAnother": "提交另一个请求"
    },
    "form": {
      "title": "2FA重置请求",
      "description": "失去了对2FA设备的访问权限？填写此表单向我们的安全团队请求重置。",
      "securityNotice": "⚠️ 重要安全提示",
      "notice1": "• 此过程需要我们安全团队的人工审核",
      "notice2": "• 请提供尽可能准确的信息以加快验证速度",
      "notice3": "• 虚假信息将导致请求被拒绝",
      "notice4": "• 处理时间：1-3个工作日",
      "requiredInformation": "必填信息",
      "emailAddress": "邮箱地址 *",
      "fullName": "全名 *",
      "reason": "2FA重置原因 *",
      "additionalVerification": "额外验证（可选但推荐）",
      "lastLoginDate": "大概的最后登录日期",
      "accountCreationDate": "大概的账户创建日期",
      "recentActivity": "最近的账户活动",
      "securityQuestionsTitle": "安全问题",
      "securityQuestionsDescription": "回答这些问题以帮助验证您的身份。如果不知道请留空。",
      "submittingRequest": "正在提交请求...",
      "submitButton": "提交2FA重置请求",
      "backToLogin": "返回登录",
      "rememberDevice": "记得您的2FA设备吗？",
      "tryVerification": "尝试2FA验证",
      "placeholders": {
        "email": "输入您的账户邮箱地址",
        "fullName": "输入您注册时的全名",
        "reason": "解释为什么需要重置2FA（例如：手机丢失、设备损坏等）",
        "lastLoginDate": "例如：2024年12月15日",
        "accountCreationDate": "例如：2024年11月",
        "recentActivity": "描述最近的活动（交易、等级变更、付款等）",
        "yourAnswer": "您的答案"
      }
    }
  },
  "verify2FA": {
    "title": "双重身份验证",
    "description": "6位验证码已发送到您的邮箱地址",
    "form": {
      "verificationCode": "验证码",
      "placeholder": "输入6位验证码",
      "verifying": "验证中...",
      "verifyCode": "验证代码"
    },
    "errors": {
      "sessionExpired": "会话已过期",
      "pleaseLoginAgain": "请重新登录。",
      "enterCode": "请输入验证码",
      "codeMustBe6Digits": "验证码必须是6位数字",
      "verificationFailed": "验证失败",
      "verificationFailedTitle": "验证失败",
      "invalidCode": "无效的验证码",
      "failedToResendCode": "重发验证码失败",
      "failedToResendTitle": "重发失败"
    },
    "success": {
      "loginSuccessful": "登录成功",
      "welcomeBack": "欢迎回来！",
      "codeSent": "验证码已发送",
      "codeSentDescription": "新的验证码已发送到您的邮箱。"
    },
    "help": {
      "needHelp": "需要帮助？",
      "sending": "发送中...",
      "resendCode": "重发验证码",
      "backToLogin": "返回登录",
      "lostDevice": "丢失2FA设备？请求重置",
      "didntReceiveCode": "没有收到验证码？请检查垃圾邮件文件夹或",
      "resendIt": "重新发送",
      "byContinuing": "继续即表示您同意我们的",
      "termsOfService": "服务条款",
      "privacyPolicy": "隐私政策"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "邮箱地址是必需的",
      "sendFailed": "发送密码重置邮件失败",
      "requestFailed": "请求失败"
    },
    "success": {
      "emailSent": "重置邮件已发送",
      "title": "检查您的邮箱",
      "description": "如果此邮箱存在账户，您将收到密码重置链接。",
      "emailSentTitle": "邮件已发送",
      "emailSentMessage": "如果账户存在，我们已向{{email}}发送了密码重置链接。",
      "instruction1": "• 如果没有看到邮件，请检查您的垃圾邮件文件夹",
      "instruction2": "• 重置链接将在1小时后过期",
      "instruction3": "• 如有需要，您可以请求另一个重置",
      "sendAnother": "发送另一封重置邮件",
      "backToLogin": "返回登录"
    },
    "form": {
      "title": "忘记密码",
      "description": "输入您的邮箱地址，我们将向您发送重置密码的链接。",
      "emailAddress": "邮箱地址",
      "placeholder": "输入您的邮箱地址",
      "sending": "发送中...",
      "sendResetLink": "发送重置链接",
      "backToLogin": "返回登录",
      "noAccount": "没有账户？",
      "signUp": "注册",
      "lost2FA": "失去了对2FA设备的访问权限？",
      "request2FAReset": "请求2FA重置"
    },
    "security": {
      "title": "安全提示",
      "note1": "• 密码重置仅适用于传统账户",
      "note2": "• Google OAuth用户应使用\"使用Google登录\"",
      "note3": "• 出于安全考虑，重置链接将在1小时后过期"
    }
  }
};
